import { useEffect } from 'react'
import { DiscountType } from 'typings'
import { useFormStateContext } from '../../../../..'
import { useConditions } from '../../useConditions'

type Props = {
  name: string
}

/**
 * Hides the shipping methods condition when the benefit is shipping type
 */
export function useShippingMethodsRelation(props: Props) {
  const { name } = props
  const { form } = useFormStateContext()

  const { discountType } = useFormStateContext()

  const { hide, show } = useConditions()

  useEffect(() => {
    if (discountType === DiscountType.Shipping) {
      hide(name)
      form.setValue(name, undefined)
    } else {
      show(name)
    }
  }, [discountType, form, hide, name, show])
}
